import { useEffect, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Select, type SelectProps } from '@wf/components';

import { getSelectOptionsFromObjectArray } from '../../../../../../helpers/getSelectOptionsFromObjectArray';
import { ogaStatusesSelector } from '../../../../../../store/licenseType/selectors';
import { getOgaStatuses } from '../../../../../../store/licenseType/actions';
import { SearchSelectField } from '../../../../configs';

function OgaStatusSelect({ onChange, ...rest }: SelectProps<SelectOption>) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const { data: ogaStatuses, loading } = useSelector(ogaStatusesSelector);

  const ogaStatusesSelectOptions = useMemo(
    () =>
      getSelectOptionsFromObjectArray(
        ogaStatuses,
        i18n.resolvedLanguage === 'en' ? 'status' : 'statusInNatLng',
        'status',
        null,
        t
      ),
    [i18n.resolvedLanguage, ogaStatuses, t]
  );

  useEffect(() => {
    if (!ogaStatuses.length) {
      dispatch(getOgaStatuses());
    }
  }, [dispatch, ogaStatuses]);

  return (
    <Select
      loadingMessage={() => t('Loading...')}
      name={SearchSelectField.ogaStatus}
      options={ogaStatusesSelectOptions}
      placeholder={t('Agency Status')}
      isLoading={loading}
      onChange={onChange}
      isClearable
      {...rest}
    />
  );
}

export default OgaStatusSelect;
